import {
  CircleHelpIcon,
  UserIcon,
  LogOutIcon,
  BellIcon,
  CodeXmlIcon,
} from "lucide-react";
import { Link, useNavigate } from "react-router";
import Button from "components/atoms/Button";
import { useDispatch, useSelector } from "react-redux";
import { resetUser, selectCurrentUser } from "app/slices/user/userSlice";
import Dropdown from "components/atoms/Dropdown";

function UserMenu() {
  // TODO add a more granular selector, incase model information changes
  const userModel = useSelector(selectCurrentUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <Dropdown
      buttonItem={
        <>
          <UserIcon size={16} /> {userModel.name}
        </>
      }
      direction="right"
      options={[
        <button
          onClick={() => navigate("/userChange")}
          className="flex items-center gap-2"
          data-hs-dropdown-close
        >
          <CodeXmlIcon size={16} />
          UserChange
        </button>,
        <button
          onClick={() => {
            dispatch(resetUser());
            navigate("/");
          }}
          className="flex items-center gap-2"
          data-hs-dropdown-close
        >
          <LogOutIcon size={16} />
          Sign Out
        </button>,
      ]}
    />
  );
}

export default function Navbar() {
  const navigate = useNavigate();
  return (
    <header className="flex-row flex justify-start items-start self-stretch border-b-border border-b-[1px]">
      <nav className="px-7 py-5 self-stretch flex-grow inline-flex justify-between items-center">
        <Link
          to="/"
          className="justify-start text-2xl font-bold text-text-title"
        >
          Academic Quality Enhancement
        </Link>
        {/* notif button + help + account info */}
        <div className="inline-flex justify-start items-center gap-2">
          <Button size="icon" kind="white" color="black">
            <BellIcon size={20} strokeWidth={1}></BellIcon>
          </Button>
          <Button
            size="icon"
            kind="white"
            color="black"
            onClick={() => navigate("/help")}
          >
            <CircleHelpIcon size={20} strokeWidth={1} />
          </Button>
          <UserMenu />
        </div>
      </nav>
    </header>
  );
}
